export interface InfonuagiqueItem {
  id: number;
  title: string;
  category: string;
  description: string;
  aiSuggestion: string;
  kpiScore: number;
  imageUrl?: string;
  isCompleted?: boolean;
  inKnowledgeBase?: boolean;
  scoreDany?: number;
  scoreYannick?: number;
  scoreFrancois?: number;
  visionDany?: string;
  visionYannick?: string;
  visionFrancois?: string;
}

export const infonuagiqueData: InfonuagiqueItem[] = [
  {
    id: 1,
    title: "Cloud Privé BZ - Vue d'ensemble",
    category: "Infrastructure",
    description: "Notre cloud privé offre un excellent rapport qualité/prix avec des standards de qualité très élevés et un service humain apprécié des clients du Québec et du Canada.",
    aiSuggestion: "Découvrez notre cloud privé BZ : infrastructure robuste, service humain exceptionnel, et rapport qualité/prix incomparable.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Notre cloud privé, c'est notre fierté. On a deux centres de données, des standards de qualité très élevés, et surtout, un service humain qui fait toute la différence. On n'est pas certifié TIER X ou SOC2, mais nos standards sont excellents et nos clients l'apprécient.",
    visionYannick: "Le cloud privé BZ, c'est un excellent rapport qualité/prix. On offre deux formules, collocation et environnement partagé, adaptées aux besoins de nos clients. C'est une option très appréciée au Québec et au Canada.",
    visionFrancois: "Techniquement, notre infrastructure est solide : redondance N+1, génératrices, UPS, climatisation. On a deux sites, BZ et Oricom (Serko). C'est professionnel, c'est fiable, c'est BZ."
  },
  {
    id: 2,
    title: "Collocation - Serveurs Dédiés",
    category: "Offre",
    description: "Serveurs dédiés avec responsabilité client sur le contenu (hypervisor et VM). BZ fournit le matériel et l'infrastructure physique avec nos standards de qualité de salle.",
    aiSuggestion: "Optez pour la collocation si vous avez besoin de contrôle total sur vos serveurs et votre infrastructure virtuelle.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "La collocation, c'est pour les clients qui veulent le contrôle total. Ils ont leurs serveurs dédiés, ils gèrent leur hypervisor et leurs VM. Nous, on fournit le matériel et l'infrastructure physique avec nos standards de qualité. C'est clair, c'est professionnel.",
    visionYannick: "La collocation, c'est une offre qui répond à des besoins spécifiques. Clients qui veulent leur propre infrastructure, leur propre contrôle. On leur fournit l'excellence BZ au niveau infrastructure.",
    visionFrancois: "Techniquement, en collocation, le client a la responsabilité du contenu, hypervisor et VM. Nous, on fournit le matériel, la redondance, la climatisation, les génératrices. Standards de qualité BZ."
  },
  {
    id: 3,
    title: "Environnement Partagé (IAAS)",
    category: "Offre",
    description: "Formule IAAS économique où nous partageons des serveurs pour plusieurs clients. BZ gère l'hypervisor et les VM. SPLA autorisé avec Microsoft, rigueur sur les licences.",
    aiSuggestion: "Choisissez l'environnement partagé pour une solution cloud économique avec gestion complète par BZ.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1633356122544-1341345f3c21?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "L'environnement partagé, c'est notre formule IAAS. Plus économique pour le client, on partage les serveurs, on gère l'hypervisor et les VM. On est SPLA autorisé avec Microsoft, on a une rigueur sur les licences, des audits réguliers, des rapports. C'est professionnel.",
    visionYannick: "L'environnement partagé, c'est une excellente option pour les clients qui veulent du cloud sans le coût de serveurs dédiés. On gère tout, c'est économique, c'est fiable.",
    visionFrancois: "Techniquement, en environnement partagé, BZ a la responsabilité de l'hypervisor et des VM. On est SPLA autorisé, on gère les licences Microsoft rigoureusement. Audits réguliers, rapports, procédures de validation en place."
  },
  {
    id: 4,
    title: "Infrastructure & Redondance",
    category: "Infrastructure",
    description: "Standards de qualité élevés : redondance génératrice N+1, UPS N+1, climatisation. Deux centres de données : BZ et Oricom (Serko).",
    aiSuggestion: "Bénéficiez d'une infrastructure robuste avec redondance complète pour une disponibilité maximale.",
    kpiScore: 93,
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Notre infrastructure, c'est du solide. Redondance N+1 partout : génératrices, UPS, climatisation. Deux centres de données, BZ et Oricom (Serko). On n'est pas certifié TIER X, mais nos standards sont très élevés.",
    visionYannick: "L'infrastructure BZ, c'est rassurant pour nos clients. Redondance complète, deux sites, standards de qualité. C'est professionnel, c'est fiable.",
    visionFrancois: "Techniquement, on a redondance N+1 sur génératrices, UPS, climatisation. Deux sites géographiquement séparés. Standards de qualité très élevés, même sans certification TIER X."
  },
  {
    id: 5,
    title: "Backup & Archive Long Terme",
    category: "Service",
    description: "Solutions de backup avec archive long terme - un élément fort chez BZ que peu de compétiteurs offrent. Protection complète de vos données.",
    aiSuggestion: "Protégez vos données avec nos solutions de backup et archive long terme, un avantage concurrentiel BZ.",
    kpiScore: 95,
    imageUrl: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Le backup et l'archive long terme, c'est un de nos points forts. Peu de compétiteurs offrent ça. On protège les données de nos clients, on archive, on garde tout accessible. C'est un différenciateur puissant.",
    visionYannick: "Le backup et archive long terme, c'est un service qu'on offre et que peu d'autres offrent. C'est un avantage concurrentiel, c'est rassurant pour nos clients.",
    visionFrancois: "Techniquement, on a des solutions de backup robustes avec archive long terme. C'est un service complet, professionnel, que peu de compétiteurs offrent."
  },
  {
    id: 6,
    title: "Sécurité & Accès",
    category: "Sécurité",
    description: "Accès sécurisés tant au niveau physique que virtuel. Contrôles d'accès stricts, monitoring continu, protection complète de votre infrastructure.",
    aiSuggestion: "Bénéficiez d'une sécurité complète avec contrôles d'accès physiques et virtuels rigoureux.",
    kpiScore: 91,
    imageUrl: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "La sécurité, c'est essentiel. On sécurise les accès, physiques et virtuels. Contrôles stricts, monitoring continu. C'est notre responsabilité, on la prend au sérieux.",
    visionYannick: "La sécurité des accès, c'est rassurant pour nos clients. Ils savent que leurs données sont protégées, que les accès sont contrôlés. C'est professionnel.",
    visionFrancois: "Techniquement, on a des contrôles d'accès stricts, physiques et virtuels. Monitoring continu, protection complète. Standards de sécurité élevés."
  },
  {
    id: 7,
    title: "Gestion des Licences Microsoft (SPLA)",
    category: "Gestion",
    description: "SPLA autorisé avec Microsoft. Rigueur sur la gestion des licences avec procédures de validation en place, audits réguliers et rapports détaillés.",
    aiSuggestion: "Profitez d'une gestion rigoureuse des licences Microsoft SPLA avec audits réguliers et conformité garantie.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1633356122544-1341345f3c21?w=800&q=80",
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "On est SPLA autorisé avec Microsoft. On a une rigueur sur la gestion des licences, des procédures de validation, des audits réguliers, des rapports. C'est professionnel, c'est conforme, c'est BZ.",
    visionYannick: "La gestion SPLA, c'est un avantage. On est autorisé, on gère les licences rigoureusement, on fait des audits. C'est rassurant pour nos clients, c'est conforme.",
    visionFrancois: "Techniquement, on est SPLA autorisé. On a des procédures de validation, des audits réguliers, des rapports. Gestion rigoureuse des licences Microsoft."
  },
  {
    id: 8,
    title: "Service Client & Support",
    category: "Service",
    description: "Service humain exceptionnel qui rend notre cloud privé une option très appréciée des clients du Québec et du Canada. Support réactif et personnalisé.",
    aiSuggestion: "Bénéficiez d'un service client exceptionnel qui fait la différence dans votre expérience cloud.",
    kpiScore: 94,
    imageUrl: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80",
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "Le service client, c'est notre force. On n'est pas certifié SOC2 ou TIER X, mais notre service humain, c'est ça qui fait la différence. Nos clients du Québec et du Canada l'apprécient énormément.",
    visionYannick: "Le service client BZ, c'est un différenciateur. Support réactif, personnalisé, humain. C'est ça qui fait que nos clients nous choisissent et nous restent fidèles.",
    visionFrancois: "Techniquement, on offre un support réactif et professionnel. Service humain qui fait la différence. C'est un avantage concurrentiel."
  }
];












